import { catchError, Observable, tap, throwError } from 'rxjs';
import { FinanceClientPriceModelClient, FinanceClientPriceModelDTO, FinancePriceModelDataDTO } from './../../../../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})

export class FinanceClientPriceModelService {

  constructor(private priceModelClient: FinanceClientPriceModelClient,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
  ) { }

  public getPriceModel(clientId: number): Observable<FinanceClientPriceModelDTO[]> {
    this.spinnerService.showSpinner = true;
    return this.priceModelClient.getFinanceClientPriceModels(clientId)
      .pipe(
        tap(() => this.spinnerService.showSpinner = false),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public updatePriceModel(data: FinanceClientPriceModelDTO) {
    this.spinnerService.showSpinner = true;
    return this.priceModelClient.updateFinanceClientPriceModel(data)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess('i18n.domain.client-administration.price-model.title', 'i18n.domain.client-administration.price-model.update-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public createPriceModel(clientId: number, data: FinanceClientPriceModelDTO) {
    this.spinnerService.showSpinner = true;
    return this.priceModelClient.addFinanceClientPriceModel(clientId, data)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess('i18n.domain.client-administration.price-model.title', 'i18n.domain.client-administration.price-model.add-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public getPriceModelMasterData(): Observable<FinancePriceModelDataDTO> {
    this.spinnerService.showSpinner = true;
    return this.priceModelClient.getAllPriceModels()
      .pipe(
        tap(() => this.spinnerService.showSpinner = false),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public deletePriceModel(priceModelId: number) {
    this.spinnerService.showSpinner = true;
    return this.priceModelClient.deleteFinanceClientPriceModel(priceModelId)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess('i18n.domain.client-administration.price-model.title', 'i18n.domain.client-administration.price-model.delete-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

}
